import React, { FC } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton, IconButtonProps, SxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { ColorGray } from "./theme";

const StyledButton = styled(IconButton)(({ theme }) => ({
  fontSize: "15px",
  "&:hover, &:focus": {
    [`& svg > path`]: {
      color: `${theme.palette.error.main} !important`,
    },
  },
}));

interface IgCloseButtonProps extends IconButtonProps {
  component?: any;
  componentsx?: SxProps;
  closeiconcolor?: string;
}

/**
 * @see IconButton
 */
export const IgCloseButton: FC<IgCloseButtonProps> = (props) => {
  return (
    <StyledButton size={"small"} {...props}>
      <CloseIcon
        sx={{
          ...props.componentsx,
          color: props.closeiconcolor ?? ColorGray.mid,
        }}
      />
    </StyledButton>
  );
};
